'use client'

import PageAnchorsDropdown from '@/components/page-anchors/PageAnchorsDropdown'
import PageAnchorsList from '@/components/page-anchors/PageAnchorsList'

export type AnchorItem = {
  title: string
  anchor_id: string
}

export default function PageAnchors({
  anchors,
  label,
  style = 'list',
}: {
  anchors: AnchorItem[]
  label?: string
  style?: 'list' | 'dropdown'
}) {
  if (style === 'dropdown') {
    return <PageAnchorsDropdown anchors={anchors} label={label} />
  }

  return <PageAnchorsList anchors={anchors} label={label} />
}
